module.exports = __webpack_public_path__ + "static/media/experiments.eaa8574b.svg";